import NotificationWidget from './NotificationWidget';
import { Config } from './types';
import NotificationWidgetControl from './NotificationWidgetControl';
import { defaultPaddingData, defaultBorderData } from 'builder/util/constants';

export default {
  type: 'NotificationWidget',
  displayName: 'NotificationWidget',
  icon: 'Bell',
  initialConfig: {
    ...defaultPaddingData,
    ...defaultBorderData,
    backgroundData: { style: 'None', color: '#FFFF' },
    uniqueId: 'notif123',
    width: 150,
    height: 65,
    minWidth: 100, // Added from Config
    minHeight: 50, // Added from Config
    xLocation: 20,
    yLocation: 20,
    visible: true,
    lineColor: '#000000', // Added from Config
    checked: 'false', // Added from Config
    notifications: [], // Added from Config
    font: 'OptumSans', // Added from Config
    fontSize: 14, // Added from Config
    bold: false, // Added from Config
    italic: false, // Added from Config
    underline: false, // Added from Config
    strikeThrough: false, // Added from Config
    fontFamily: 'OptumSans',
    lineSpacing: 1,
    characterSpacing: 1, // Added from Config
    textColor: '#000000', // Added from Config
  },
  components: {
    render: NotificationWidget,
    control: NotificationWidgetControl,
  },
  copyable: true,
} as HorizonWidgetDefinition<Config>;
